/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_TitleInputs */

const en_directory_submit_title = /** @type {(inputs: Directory_Submit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit an AI Tool`)
};

const zh_directory_submit_title = /** @type {(inputs: Directory_Submit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交 AI 工具`)
};

/**
* | output |
* | --- |
* | "Submit an AI Tool" |
*
* @param {Directory_Submit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_title = /** @type {((inputs?: Directory_Submit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_title(inputs)
	return zh_directory_submit_title(inputs)
});
export { directory_submit_title as "directory.submit.title" }